import apiFetch from '@nrdy-marketing-engine/api-fetch/src/api-fetch';
import { SubjectDirectoryResult } from '@nrdy-marketing-engine/organic/app/types/subject-directory-result';
import displayable from './displayable';

async function fetchSubject(subject: string): Promise<SubjectDirectoryResult | null> {
  if (!subject) return null;

  try {
    const path = `/vtwa/v1/subject_directory/lookup?subject=${subject}`;
    const response = await apiFetch<{ data: SubjectDirectoryResult }>(path);
    return displayable(response.data, 'display_name');
  } catch (err) {
    return null;
  }
}

export default fetchSubject;
